export default __webpack_public_path__ + "static/media/Mark-3-HUD-Dock Icons.d9c63115.jpg";